import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useCompanyDashboardContext } from 'dashboard409a/context/CompanyDashboardContext/CompanyDashboardContext';
import { IValuationState } from 'dashboard409a/states/features/valuation';
import { RootStateType } from 'dashboard409a/states/store';
import Information from './Information';

const InformationData: React.FC = () => {
  const { currentCompany, currentMeasurementDateId, currentCompanyMeasurementDateId }
    = useSelector((state: RootStateType) => state.global);
  const { currentValuationScalarOpinion } = useSelector<RootStateType, IValuationState>(
    state => state.valuation
  );
  const { updatePageActions } = useCompanyDashboardContext();

  useEffect(() => {
    if (updatePageActions) {
      updatePageActions(null);
    }
  }, [updatePageActions]);

  if (!currentValuationScalarOpinion?.report_date?.measurement_date) {
    return null;
  }

  return (
    <Information
      is409a
      currentCompany={currentCompany}
      currentMeasurementDateId={currentMeasurementDateId}
      currentCompanyMeasurementDateId={currentCompanyMeasurementDateId}
      selectedMeasurementDate={currentValuationScalarOpinion.report_date.measurement_date}
    />
  );
};

export default InformationData;
